import { useCurrentUser } from '~/composables/useCurrentUser'

export default defineNuxtRouteMiddleware(async () => {
  const { currentUser } = useCurrentUser()

  if (!currentUser.value || !currentUser.value.canEditLocation) {
    return await navigateTo({
      name: 'index',
    })
  }
})
